import {combineReducers} from "redux";
import {entitiesReducer} from "modules/ConfigManager/services/Entities/reducer";
import {createEditConfigReducer} from "modules/ConfigManager/services/CreateEditConfig/reducer";

export const configManagerReducer = combineReducers({
    entries: entitiesReducer,
    createEditConfig: createEditConfigReducer,
});